import React from 'react';
import { Link } from 'react-router-dom';
import { Loader2, Lock, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';

function Field({ label, value, onChange, type = 'text', required, testid, hint, placeholder }) {
  return (
    <div>
      <label className="block text-xs text-slate-400 mb-1.5">{label}{required && <span className="text-rose-400">*</span>}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        placeholder={placeholder}
        data-testid={testid}
        className="w-full rounded-lg bg-white/5 border border-white/10 text-white placeholder:text-slate-500 px-3 py-2.5 text-sm outline-none focus:border-indigo-500/60 focus:bg-white/[0.07] transition-colors"
      />
      {hint && <div className="text-[10px] text-slate-500 mt-1">{hint}</div>}
    </div>
  );
}

export default function SignupForm({ form, setForm, onSubmit, busy, selected, interval, fmtEUR, captcha, displayPrice }) {
  const priceShown = typeof displayPrice === 'number' ? displayPrice : selected.price_eur;
  // 26/09 : plus aucune periode d essai (decision de Marlon du 25/09) — le bouton
  // annonce toujours le prix reellement debite, jamais « gratuit pendant N jours ».
  // displayPrice arrive TOUJOURS ramene au mois (Subscribe.jsx divise par le nombre de
  // mois payes), donc le rythme affiche reste « /mois » quel que soit l engagement.
  const rythme = '/mois';
  return (
    <form className="space-y-4" onSubmit={onSubmit}>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Prénom" value={form.first_name} onChange={(v) => setForm({ ...form, first_name: v })} required testid="subscribe-firstname" />
        <Field label="Nom" value={form.last_name} onChange={(v) => setForm({ ...form, last_name: v })} required testid="subscribe-lastname" />
      </div>
      <Field label="Nom de l’agence" placeholder="ex. Paris Studios" value={form.organization} onChange={(v) => setForm({ ...form, organization: v })} required testid="subscribe-agency" />
      <Field label="E-mail professionnel" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} required testid="subscribe-email" />
      <Field label="Mot de passe" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} required testid="subscribe-password" hint="8 caractères minimum" />

      <label className="flex items-start gap-2 text-xs text-slate-400 cursor-pointer" data-testid="subscribe-tos">
        <input
          type="checkbox"
          checked={form.accept}
          onChange={(e) => setForm({ ...form, accept: e.target.checked })}
          className="mt-0.5 rounded border-white/20 bg-white/5 text-indigo-500 focus:ring-indigo-500/30"
        />
        <span>
          J’accepte les{' '}
          <Link to="/legal/terms" target="_blank" className="text-indigo-300 hover:underline">conditions d’utilisation</Link>{' '}
          et la{' '}
          <Link to="/legal/privacy" target="_blank" className="text-indigo-300 hover:underline">politique de confidentialité</Link>{' '}
          de ChatHub.
        </span>
      </label>

      {captcha}

      <Button type="submit" disabled={busy} data-testid="subscribe-submit" className="w-full bg-gradient-to-r from-indigo-500 to-violet-500 hover:from-indigo-600 hover:to-violet-600 text-white h-12 text-base font-medium shadow-lg shadow-indigo-500/30">
        {busy ? <Loader2 size={18} className="mr-2 animate-spin" /> : <Lock size={18} className="mr-2" />}
        {`S’abonner — ${fmtEUR(priceShown)}${rythme}`}
        <ArrowRight size={16} className="ml-2" />
      </Button>

      <p className="text-[11px] text-slate-500 text-center">
        Vous avez déjà un compte ?{' '}
        <Link to="/auth/login" className="text-indigo-300 hover:underline">Se connecter</Link>
      </p>
    </form>
  );
}
